import { SexEnum } from '../../models/sex.enum';
import { PoolerUser } from '../../models/user';

export function getPoolerTransferEligibilityQuery(
  user: PoolerUser,
  options: { ignorePoolerDepartmentAssignment?: boolean } = {},
): object {
  const poolerTypeIds: string[] = [];
  const departmentIds: string[] = [];
  if (user.customerInformation) {
    Object.keys(user.customerInformation).forEach((customerId) => {
      const customerInformation = user.customerInformation?.[customerId];
      if (customerInformation?.poolerType) {
        poolerTypeIds.push(customerInformation.poolerType.id);
      }
      if (customerInformation?.departmentIds) {
        departmentIds.push(...customerInformation.departmentIds);
      }
    });
  }

  return {
    $and: [
      {
        $or: [
          { sex: SexEnum.ALL },
          { sex: user.sex },
          { sex: { $exists: false } },
        ],
      },
      {
        $or: [
          { car: { $exists: false } },
          { car: { $lte: user.car || -1 } },
        ],
      },
      {
        $or: [
          { specialities: { $exists: false } },
          { specialities: { $size: 0 } },
          {
            'specialities.id': {
              $in: user.specialities?.map((speciality) => speciality.id) || [],
            },
          },
        ],
      },
      {
        $or: [
          { certificates: { $exists: false } },
          { certificates: { $size: 0 } },
          {
            'certificates.id': {
              $in:
                user.certificates?.map((certificate) => certificate.id) || [],
            },
          },
        ],
      },
      {
        $or: [
          { poolerTypes: { $exists: false } },
          { poolerTypes: { $size: 0 } },
          { 'poolerTypes.id': { $in: poolerTypeIds } },
        ],
      },
      {
        $or: [
          { language: { $exists: false } },
          { language: { $in: user.languages || [] } },
        ],
      },
      options.ignorePoolerDepartmentAssignment
        ? {
            'department.id': {
              $nin: user.userPreferenceDepartmentBlacklist || [],
            },
          }
        : {
            'department.id': {
              $in: departmentIds,
              $nin: user.userPreferenceDepartmentBlacklist || [],
            },
          },
    ],
  };
}
